import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import styles from '../GeneralSettings.module.scss';
import HierarchyManager from './HierarchyManager';
import { Grid } from '@mui/material';
import HierarchyList from './HierarchyList';

export interface OrganizationalHierarchySettingsProps {
	handleFocusChange?: (
		focus: | 'organization'
			| 'workplace'
			| 'user'
			| 'organizational_hierarchy'
			| 'security_role'
			| 'partners'
			| null
	) => void;
	inFocus: | 'organization'
			| 'workplace'
			| 'user'
			| 'organizational_hierarchy'
			| 'security_role'
			| 'partners'
			| null;
}

function OrganizationalHierarchySettings(props: OrganizationalHierarchySettingsProps) {
	const { handleFocusChange, inFocus } = props;

	const [viewMode, setViewMode] = useState<'list' | 'edit'>('list');
	const [selectedNodeId, setSelectedNodeId] = useState<string | null>(null);

	const handleEditClick = (nodeId: string) => {
		setSelectedNodeId(nodeId);
		handleFocusChange?.('organizational_hierarchy');
		setViewMode('edit');
	};

	const handleBackClick = () => {
		setViewMode('list');
		handleFocusChange?.(null);
		setSelectedNodeId(null);
	};

	const handleSave = () => {
		// TODO: Implement save functionality
		setViewMode('list');
		handleFocusChange?.(null);
		setSelectedNodeId(null);
	};

	switch (viewMode) {
		case 'list':
			return (
				<div className={styles.workplaceCard}>
					<div className={styles.header}>
						<h2 className={styles.formTitle}>Organization Hierarchy</h2>
						{/* <Button 
							onClick={() => {
								// Access refetch through a ref or state management
								window.location.reload();
							}} 
							variant="outline" 
							size="sm"
						>
							Refresh
						</Button> */}
					</div>
					<HierarchyList onEditClick={handleEditClick} inFocus={inFocus} />
				</div>
			);
		case 'edit':
			return (
				<div className={styles.showWorkplaceContainer}>
					<HierarchyManager
						selectedNodeId={selectedNodeId}
						handleBackClick={handleBackClick}
						handleSave={handleSave}
					/>
				</div>
			);
		default:
			return null;
	}
}

export default OrganizationalHierarchySettings;
